import { IPolicyType } from "@/api/policy-types";
import { LinkRouter } from "@/components/shared/buttons/LinkRouter";

interface IProps {
    policyType: IPolicyType;
}

export const PolicyTypeDetailsButton = ({ policyType }: IProps) => {
    return (
        <LinkRouter to={`/admin/policy-types/${policyType.id}/details`}>
            {policyType.name}
        </LinkRouter>
    );
};
